/* eslint-disable max-len */
import Waterfall from "../../assets/waterfall-blog.jpg";
import Leaf from "../../assets/leaf.jpeg";
import Palm from "../../assets/palm.jpg";
import Valley from "../../assets/valley.jpg";
import Trustee from "../../assets/Trustee1.png";

export type Blog = {
  title: string;
  description: string;
  blog?: number;
  category?: string;
  openInNew?: boolean;
  id?: string;
  buttonText?: string;
};

type BlogCollection = {
  [key: string]: Blog;
};

const blogs: BlogCollection = {
  "1": {
    blog: 5,
    title: "Why EFTs are the asset-backed NFTs the world really needs",
    category: "EcoFutures",
    description:
      "EcoFutures is a portal bringing Earth’s natural environments on-chain as TREEs (EFT) asset-backed NFTs.",
  },
  "2": {
    title: "Why you should seriously think about EFTs",
    category: "EcoFutures",
    description: `Unlike traditional assets with values that may fluctuate based on market trends, 
      the ecological value of lands is set only to increase as natural environments get rarer.`,
  },
  "3": {
    blog: 4,
    title: "Browse verified lands",
    description: `EFTs are pegged to the ecological wealth of real-world lands,
     allowing individuals and businesses to invest directly in nature, offset carbon and advocate environmental sustainability.`,
  },
  "4": {
    openInNew: true,
    blog: 3,
    title: "How to list your land with EcoFutures",
    description: `Becoming an EcoFutures Guardian begins with getting referred to the platform by someone with an EcoFutures ‘Guardian Account’...
     <br/><br/>
          TBD by Public Works...`,
  },
  "6": {
    blog: 3,
    title: "How to list your land with EcoFutures",
    description: `Becoming an EcoFutures Guardian begins with getting referred to the platform by someone with an EcoFutures ‘Guardian Account’. 
          <br/><br/>
          (Side note: If you get a Guardian Account on EcoFutures, this means you receive 3% of
          green currency every time a land uploaded by someone that you referred to the platform gets sold). 
          <br/>
          <br/>
          Listing with EcoFutures is straightforward. You start by entering your referral code on the platform. 
          <br/>
          It requires key information like the name listed on the land deed, your country code, and phone number. 
          <br/>
          <br/>
          Uploading your land registration deed or a legally binding lease agreement is a recommended step for verification and EcoFutures
          guarantees the safety and confidentiality of all submitted documents. 
          <br/><br/>
          However, if you don’t wish to upload the deeds, there is the option to submit them to the EcoFutures Trustee in person.`,
  },
  "5": {
    blog: 3,
    title: "Important",
    description: `<style>
        .scan-intro-grid {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .scan-intro-grid .scan-intro-section {
          width: 100%;
        }
        .scan-intro-grid .scan-intro-section h3 {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 12px 0;
          color: #333;
        }
        .scan-intro-grid ul {
          margin: 0;
          padding-left: 20px;
        }
        .scan-intro-grid li {
          font-size: 14px;
          margin-bottom: 8px;
          line-height: 1.5;
        }
        .scan-intro-grid .scan-intro-text {
          font-size: 14px;
          line-height: 1.6;
        }
        @media (min-width: 768px) {
          .scan-intro-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }
        }
      </style>
      <div class="scan-intro-grid">
        <div class="scan-intro-section">
          <h3>What you'll need:</h3>
          <ul>
            <li>Legitimate land ownership documents</li>
            <li>Land survey</li>               
            <li>Land elevations</li>
            <li>Profile image for the land</li>
            <li>Ensure you have funds in your wallet for the processing fee — {{VERIFICATION_FEE_PER_HECTARE}} per hectare + additional $50 USD for verification fees.</li>
          </ul>
        </div>
        <div class="scan-intro-section">
          <h3>Before you begin:</h3>
          <div class="scan-intro-text">
            Make sure you have all the correct information and documents. Once the information is submitted, you won't be able to make changes until the verification is complete.
            <br/><br/>
            <a href="/help?blog=guardian-steps" style="color: black; text-decoration: underline;" target="_blank" rel="noopener noreferrer">Here's our in-depth story</a> covering this process step by step.
          </div>
        </div>
      </div>`,
  },
  "7": {
    blog: 4,
    title: "Decoding the EcoScore; the science behind EFTs bringing ecological assets on-chain",
    description: `TREEs are pegged to the ecological wealth of real-world lands, allowing individuals and businesses to invest directly in nature, offset carbon and advocate environmental sustainability.`,
  },
};

enum ArticleContentType {
  image = "image",
  subtitle = "subtitle",
  paragraph = "paragraph",
}

type ArticleContentItem = {
  [ArticleContentType.image]?: { url: string; by?: string };
  [ArticleContentType.subtitle]?: string | { id: string; text: string };
  [ArticleContentType.paragraph]?: JSX.Element;
};

export interface SupportArticle {
  title: string;
  thumbnail?: {
    url: string;
    by?: string;
  };
  updated: string;

  data?: ArticleContentItem[];
}

type ArticleCollection = {
  [key: string]: SupportArticle;
};



export const Articles: ArticleCollection = {
  "blog-article-1": {
    title: "Why you should seriously think about EFTs",
    thumbnail: { url: Waterfall, by: "Himash Shavinda" },
    updated: "Sep 11, 2024",
    data: [
      { subtitle: { id: "summary", text: "Here’s a summary:" } },
      {
        paragraph: (
          <ul>
            {/* <span style={{ fontWeight: 600 }}>Here’s a summary:</span> */}
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub11");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>EFTs are asset-backed NFTs that rise in value as the rarity of natural environments increases.</li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub12");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              These NFTs are tied to real-world assets with ecological value; like small jungles, permaculture farms or
              nature reserves.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub13");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              Stable and very likely to appreciate within the next decade; EFTs have strong utility, limited supply, and
              growing demand as more people start nodding to the idea of combining their investment efforts with the
              need to support Earth’s preservation. There’s a high potential to develop a bull market in the next cycle.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub14");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>EFT whitepaper is now available.</li>
          </ul>
        ),
      },
      { subtitle: { id: "sub11", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures Tokens (EFTs) are green asset-backed NFTs using the growing scarcity of natural environments to
            draw capital gain from real-world ecological assets. The money invested in EFTs goes directly to support
            natural environments and communities that sustain them. With soaring global temperatures and grim warnings
            from climate science in the backdrop, the timing of EFTs makes sense whether you’re doing it for the cause,
            to diversify your portfolio, or for the possibility of profit. EFTs are easily one of the more meaningful
            investment opportunities out there. EFTs. Here are the key reasons why EFTs are poised to appreciate within
            the next decade, making them a great investment aligned with the urgent need for protecting ecologies.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EFTs are asset-backed NFTs pegged to the intrinsic value of natural ecological assets rather than
            traditional commercial real estate. Within the current context of climate change, EFTs are banking on the
            ecological value of natural environments to increase faster than traditional real estate value patterns.
            With EFTs, the natural environment becomes an asset with increasing rarity that investors can bank on.
          </>
        ),
      },
      { subtitle: { id: "sub12", text: "It’s for anyone, really; early adopters get more" } },
      {
        paragraph: (
          <>
            EFTs allow you to invest directly in nature and have a say in the survival of ecological assets and the
            communities that manage their upkeep. For the generations tired of watching yet another corporation purchase
            yet another natural resource, EFTs are a welcome tool to buy back our planet into safety, one land at a
            time; a sentiment that would only gain more popularity as we experience the effects of climate change in our
            wake. For early adopters buying into EFTs while the currency mint rate is high, this means exponential
            potential for profits and growth as the NFTs increase in value with the growing rarity of natural lands.
            Beyond the potential appreciation, the investment opportunity is more when you get in on the ground floor.
            The mint rate of EFTs decreases as the total land on the platform grows. As the protocol advances through
            Fibonacci-based edition thresholds, halving events occur, reducing the number of new EFTs created and
            increasing their value, making early stakes more profitable. With all these factors combined, the returns for
            early adopters of EFTs appear incredibly promising.
          </>
        ),
      },
      { subtitle: { id: "sub13", text: "There’s a good reason to think EFTs will rise" } },
      {
        paragraph: (
          <>
            EFTs are banking on the increase of the ecological value of natural environments as they get rarer due to
            deforestation, overpopulation, overconsumption, and waste—terrible habits that we can bet humanity won’t
            shed in the next decade. Much like art increases in value after the artist’s death, the value of ecological
            assets is poised to surge as they grow increasingly rare. EFTs stand to increase in value mirroring the
            real-world assets they’re pegged to. Another factor is that a growing number of people are looking for more
            meaningful investment opportunities instead of yet another meme coin; EFTs give them precisely that. Like
            with all worthwhile asset-backed NFTs, investment opportunity and potential appreciation are the key
            benefits of early adoption when it comes to EFTs. There’s a lot of room for appreciation and a bull market
            development within the next two decades.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Like all strategically linked asset-backed NFTs, EFTs have greater stability, higher liquidity and
            reliability that many purely speculative cryptocurrencies lack. They’re the best of both worlds connecting
            the tangible value of the physical asset with the flexibility and efficiency of digital currency. EFTs offer
            instantaneous transferability and accessibility, coupled with the enduring worth of easements to land
            assets. With each EFT serving as a digital representation of a real-world ecological asset, they maintain a
            stable value, shielding investors from wild fluctuations. With EFTs, there’s enough stability to wait for
            long-term returns.
          </>
        ),
      },
      { subtitle: { id: "sub14", text: "Ecological value vs. commercial real estate" } },
      {
        paragraph: (
          <>
            EFT's have a marked difference from real estate-backed NFTs; this is that they’re pegged to the ecological
            value of a property, rather than the commercial real estate worth. The ecological value of a land is what it
            contributes in terms of oxygen output, space, water, minerals, biota, and all other factors that support
            life. This means that when it comes to ecological value, a car park in downtown Los Angeles, USA—although
            high in commercial value—would score low compared to a rainforest in Ratnapura, Sri Lanka.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EFTs offer a fresh paradigm on investments, adding more meaning to stakes beyond financial gain. For many,
            waiting for policies to protect the carbon sink and limit deforestation isn’t an option; immediate action
            possible at an individual level is urgent. With EFTs, acting on climate change and protecting the natural
            world gets democratized. Now, you don’t have to quit your job, move somewhere remote, and manage a forest;
            we can all pitch in to do it together. There has never been a better time to invest in preserving ecologies;
            and EFTs make it possible for everyone, with room for some green profits on the side.
          </>
        ),
      },
      { subtitle: "Do your own research" },
      {
        paragraph: (
          <>
            <ul>
              <li>Read the EcoFutures (EFTs) whitepaper and see why these NFTs are among the most
                meaningful investments you can make.</li>
              <br />
              <li>Read{" "}
                <a href="https://www.researchgate.net/publication/382331379_The_enduring_world_forest_carbon_sink">
                  this research paper to understand why protecting ecological assets
                </a>{" "}
                that are carbon sinks—like forests, woodlands, water bodies and oceans—is the ultimate climate action.</li>
            </ul>

          </>
        ),
      },
    ],
  },
  "blog-article-2": {
    title: "Meet the EcoFutures Trustees—people and organizations whose life’s mission is to protect the planet",
    // thumbnail: "/images/meet.png",
    thumbnail: { url: Trustee, by: "Forrest Cavale" },
    updated: "Sep 15, 2024",
    data: [

      { subtitle: { id: "summary", text: "Here’s a summary:" } },
      {
        paragraph: (
          <ul>
            {/* <span style={{ fontWeight: 600 }}>Here’s a summary:</span> */}
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub21");
              console.log(element)
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              Most often, EcoFutures Trustees are permaculture experts, ecologists, and experienced members of
              registered environmental conservation organizations.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub22");
              console.log(element)
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              Registered organizations that have been in operation for over 5 years, such as the Analog Forestry Network
              International and Rainforest Protectors Sri Lanka, also take on the role of EcoFutures Trustees.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub23");
              console.log(element)
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              {" "}
              Trustees undergo a rigorous selection process that includes verification of qualifications, identity, and
              connected digital wallets.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub24");
              console.log(element)
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              Trustees are compensated for each land verification, with payments depending on the complexity of
              geography and the analysis required.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub25");
              console.log(element)
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              Read the EcoFutures whitepaper to understand how this platform works, authenticates lands and their
              owners, and secures returns for investors.
            </li>
          </ul>
        ),
      },
      {
        paragraph: (
          <>
            EFTs are asset-backed NFTs pegged to the intrinsic value of natural ecological assets rather than
            traditional commercial real estate. Within the current context of climate change, EFTs are banking on the
            ecological value of natural environments to increase faster than traditional real estate value patterns.
            With EFTs, the natural environment becomes an asset with increasing rarity that investors can bank on.
          </>
        ),
      },
      { subtitle: { id: "sub21", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures (EFTs) are green asset-backed NFTs that bring the ecological value of nature-abundant properties
            on-chain and draw capital gain for landowners and investors. A key part of this process is ensuring
            dependable sources evaluate and verify the lands listed on the EcoFutures platform for bidding, investment
            and conservation. EcoFutures Trustees are qualified, carefully selected professionals who guarantee the
            integrity of this process. Essentially, they’re real world oracles feeding accurate data into the
            blockchain. Here’s more about the process of becoming a trustee and the financial incentives for those who
            take on this crucial role.
          </>
        ),
      },
      { subtitle: { id: "sub22", text: "Who are EcoFutures Trustees?" } },
      {
        paragraph: (
          <>
            EcoFutures trustees are not just any individuals or organizations. They are respected entities within the
            environmental conservation sphere. For instance, one of the prominent organizations serving as an EcoFutures
            Trustee is the Analog Forestry Network International. This network includes Dr. Ranil Senanayake, a UC Davis
            graduate and systems ecologist, renowned for originating the concept and science of analog forestry. Dr.
            Senanayake has designed numerous forests globally and established the first Analog Forest at the Belipola
            Training Center in Sri Lanka. His extensive experience in ecological systems, along with his global training
            sessions is exactly the calibre of expertise that EcoFutures Trustees bring to the table.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Another key trustee is the Rainforest Protectors Sri Lanka, led by Jayantha Wijeseinghe, the co-founder and
            chief organizer. This organization is a leading conservation entity in Sri Lanka, emphasizing the importance
            of preserving rainforests through active involvement and advocacy. By working with trustees who are
            knowledgeable and genuinely passionate about environmental conservation, EcoFutures can promise not only
            transparency but an accurate evaluation for landowners and a fair return to investors.
          </>
        ),
      },
      { subtitle: { id: "sub23", text: "Getting the EcoFutures Trustee status" } },
      {
        paragraph: (
          <>
            Becoming an EcoFutures Trustee is a process designed to verify both integrity and expertise. It’s initiated
            entirely online.
          </>
        ),
      },
      {
        paragraph: (
          <>
            To apply, candidates must meet specific eligibility criteria: Candidates must be ecological organizations,
            qualified ecological assessors, or international ecological bodies. They need to have been active or in
            practice for at least five years, ensuring they have substantial experience and credibility in the field.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Organizations and individuals must provide proof of address through bills or registration documents. Each
            verifier within the organization must submit proof of ID and have a connected digital wallet to receive
            payments. Applicants need to provide detailed contact information, including the organization's name, email,
            website, and phone number.
          </>
        ),
      },
      {
        paragraph: (
          <>
            This process makes sure that only qualified and experienced individuals and organizations can become
            EcoFutures Trustees, maintaining the platform's integrity and reliability.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub24", text: "The role of an EcoFutures Trustee; perks and duties",
        }
      },
      {
        paragraph: (
          <>
            EcoFutures Trustees are compensated each time they verify lands, with the payment amount varying based on
            the land extent and the complexity of each case. This compensation structure not only provides financial
            incentives for trustees but also ensures that the land verification process is thorough and scientifically
            accurate.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Trustees are responsible for conducting detailed scientific analyses of the land and assessing various
            ecological factors to determine its value. This role is crucial as it ensures that the lands listed on
            EcoFutures are genuinely sustainable and beneficial for environmental conservation. This ensures that
            investments support legitimate and environmentally impactful lands with great carbon offsetting potential
            and bigger climate benefits.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EcoFutures Trustees serve as validators for all ecological assets on the platform, taking on the critical
            role of oracles that feed real-world data to the blockchain. To minimize validation costs and avoid
            unnecessary carbon emissions from travel, trustees are part of a local network node in each country. If a
            trustee acts nefariously, EcoFutures will reassign the assets they manage to another trustee within the same
            local network.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EcoFutures Trustees play an incredibly important role in maintaining the platform's credibility and
            effectiveness. In the backdrop of unprecedented climate change, becoming an EcoFutures Trustee is more than
            just a financial decision—it’s a commitment to environmental stewardship and directly influencing the
            sustenance of living ecologies. For ecologists, environmentalists, and sustainability experts, it’s a great
            way to place their knowledge in the service of nature.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub25", text: "Wondering how much you can help the planet as an EcoFutures Trustee?",
        }
      },
    ],
  },
  "blog-article-3": {
    title: "Why tokenizing land with EcoFutures is a win-win-win for property owners",
    updated: "Sep 11, 2024",
    thumbnail: { url: Palm, by: "Hans Eiskonen" },
    data: [
      // { subtitle: "Story" },
      // {
      //   paragraph: (
      //     <>
      //       EcoFutures is a green asset-backed NFT. It links crypto investors interested in sustainability with property
      //       owners who want to conserve their lands as natural environments. The key difference here is that EcoFutures
      //       tokenizes the ecological value derived from the relationship between natural elements and the living
      //       organisms in the land, not its traditional real estate worth. This means that any land with good ecological
      //       balance—hosting healthy soil, water, air, tree cover, and biodiversity, as well as a community that sustains
      //       it—will be appraised highly by EcoFutures, regardless of its commercial valuation. For property owners with
      //       natural environments in remote areas and those who never quite wanted to sell their property to yet another
      //       highrise project or developer, EcoFutures gives a direct link to a growing community of environmentally
      //       conscious investors.
      //     </>
      //   ),
      // },
      { subtitle: "Here’s a summary:" },
      {
        paragraph: (
          <>
            <ul>
              {/* <span style={{ fontWeight: 600 }}>Here’s a summary:</span> */}
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub31");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                EcoFutures allows landowners to tokenize their land, transforming it into a digital asset on the
                blockchain.
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub32");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                These tokens, known as EFTs, represent real-world ecological assets that can be traded by investors.
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub33");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                Verified ecological assets are bridged to the blockchain through a legally binding contract between
                landowner and investor to preserve or improve the assets’ ecology.
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub34");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                EcoFutures tokenizes the ecological value of lands instead of commercial real estate value, making it a
                promising path for even remote, small lands containing living ecologies.
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub35");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                Once the land is verified and listed on the platform, the landowners join the circle of EcoFutures
                Guardians who are legally responsible for developing the property and maintaining the easements in
                return for investments.
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub36");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                EcoFutures facilitates sustainable land management while providing financial rewards to both landowners
                and investors.
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => {
                const element = document.getElementById("sub37");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}>
                It’s a solution for landowners who don’t want to sell natural environments under their care to the real
                estate market and need investors to support upkeep.
              </li>
            </ul>
          </>
        ),
      },
      { subtitle: { id: "sub31", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures is a green asset-backed NFT. It links crypto investors interested in sustainability with property
            owners who want to conserve their lands as natural environments. The key difference here is that EcoFutures
            tokenizes the ecological value derived from the relationship between natural elements and the living
            organisms in the land, not its traditional real estate worth. This means that any land with good ecological
            balance—hosting healthy soil, water, air, tree cover, and biodiversity, as well as a community that sustains
            it—will be appraised highly by EcoFutures, regardless of its commercial valuation. For property owners with
            natural environments in remote areas and those who never quite wanted to sell their property to yet another
            highrise project or developer, EcoFutures gives a direct link to a growing community of environmentally
            conscious investors.
          </>
        ),
      },
      { subtitle: { id: "sub32", text: "Easing the pressures of inheritance, rising land taxes, and more" } },
      {
        paragraph: (
          <>
            EFTs are a solution for financial pressures that come with estate inheritance, rising property taxes, and
            other burdens of land ownership; such as managing invasive species, maintaining biodiversity, protecting
            against illegal logging or poaching, complying with environmental regulations, and mitigating natural
            disasters like wildfires or floods. Even beyond these, landowners face ongoing expenses related to soil
            conservation against erosion, water management, and restoration of degraded areas. EcoFutures allows
            landowners to maintain the ecological integrity of their property while benefiting from a steady stream of
            investment, balancing conservation and economic viability.
          </>
        ),
      },
      { subtitle: { id: "sub33", text: "What to investors get?" } },
      {
        paragraph: (
          <>
            Depending on the tiers set by the landowners during the listing process, investors get access to easements
            or yields (or both) for a set time. These easements can include rights such as access to certain areas,
            harvest of produce, or accommodations on the land. The tiers, entirely up to the landowner and detailed
            during the listing process, outline the specific benefits that investors can unlock. This approach
            guarantees that both landowners and investors can align their goals, providing clear, quantifiable returns
            and commitments while supporting sustainable land management. Land conservation and development covenants
            and easement rights are coded into the EFT smart contract, allowing both landowners and investors to
            transact with more transparency and security. The green bond, which is a contract signed between the
            landowner and the EcoFutures Trust bringing further transparency and commitment to agreed terms.
          </>
        ),
      },
      { subtitle: { id: "sub34", text: "How to list your land with EcoFutures" } },
      {
        paragraph: (
          <>
            Becoming an EcoFutures Guardian begins with getting referred to the platform by someone with an EcoFutures
            ‘Guardian Account’. (Side note: If you get a Guardian Account on EcoFutures, this means you receive 3% of
            green currency every time a land uploaded by someone that you referred to the platform gets sold). Listing
            with EcoFutures is straightforward. You start by entering your referral code on the platform. It requires
            key information like the name listed on the land deed, your country code, and phone number. Uploading your
            land registration deed or a legally binding lease agreement is a recommended step for verification and
            EcoFutures guarantees the safety and confidentiality of all submitted documents. However, if you don’t wish
            to upload the deeds, there is the option to submit them to the EcoFutures Trustee in person.
          </>
        ),
      },
      {
        paragraph: (
          <>
            When you upload a GIF file that represents your land, make sure it’s an original made using images of your
            land. A quick Google search will help you make your own GIF, and most phones also have in-built GIF makers
            in the resident software attached to the gallery. Details about your land’s location, including the country,
            province, region, and GPS coordinates are also part of the listing process. Describing your land is an
            essential step where you name your land, specify its size, and provide the lowest and highest elevation
            points along with the category that best describes your land, whether it’s a forest, river, mountain, or
            another type.
          </>
        ),
      },
      {
        paragraph: (
          <>
            The listing process also requires describing the plant and animal life on your land, identifying any built
            structures such as cabins or campsites, and listing any produce grown on the land. Uploading additional
            supporting documents, like a land survey, can help with the verification process.
          </>
        ),
      },
      {
        paragraph: (
          <>
            When it comes to easement rights and bidding, describe what investors will receive, such as organic produce
            or accommodations. Consider a fair return that you can realistically deliver from your land as it is or as
            part of proposed developments. Setting a starting bid in USD and specifying the duration of the bidding
            period are crucial steps. You’ll also outline any minimal project development included with the investment
            setting practical goals that you can guarantee to your future investors.
          </>
        ),
      },
      {
        paragraph: (
          <>
            It’s as easy as that. Make sure your documents are scanned using a high-resolution scanner, in color,
            avoiding distortions or shadows.
          </>
        ),
      },
      { subtitle: { id: "sub35", text: "What's next?" } },
      {
        paragraph: (
          <>
            Once your land is listed, it will go through the verification process by an EcoFutures Trustee. This
            involves an initial verification to confirm land ownership and the accuracy of the documents you submitted,
            and a visit to your land followed by biannual checks to assess its ecological health.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Your land will be represented virtually on the platform as a digital twin with its ecological health
            determined using an EcoScore—a scoring system determined by an eight-point Ecomatrix calculating the current
            ecological health of your asset as validated by an EcoFutures Trustee. The EcoScore is directly connected to
            the value of asset-backed NFTs your land will be auctioned for. Legal obligations require all EcoFutures
            Guardians to follow applicable laws and maintain the ecological health of their land.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Asset-backed tokens are already changing the real estate industry. But, green tokens like EFTs are game
            changers at a whole other level, imbuing meaningfulness to the processes of land guardianship and
            investment. This is why for landowners, listing with EcoFutures is one decision that can tick many boxes
            from strengthening finances to easing the conscience. Knowing that you’re building partnerships with
            investors who care about sustainability and making an income while contributing to the restoration of our
            planet’s balance is a sure win-win-win.
          </>
        ),
      },
      { subtitle: { id: "sub36", text: "Want to see how EcoFutures Guardians are using investments to maintain and develop natural environments?" } },
    ],
  },
  "blog-article-4": {
    title: "Decoding the EcoScore; the science behind EFTs bringing ecological assets on-chain",
    thumbnail: {
      url: Leaf, by: "Uwe Jelting"
    },
    updated: "Sep 11, 2024",
    data: [
      // { subtitle: "Story" },
      // {
      //   paragraph: (
      //     <>
      //       EcoFutures (EFTs) is a green asset-backed NFT representing stakes in real-world lands that host living
      //       ecologies. EFTs facilitate a transparent, immutable and tamper-proof mechanism to support ecological assets
      //       for people and businesses that want to offset carbon emissions, advocate environmental sustainability, and
      //       support local communities that sustain natural ecosystems. With EFTs, you can directly invest in natural
      //       environments because the underlying asset they represent is the ecological value of a land parcel, not its
      //       commercial real estate value. The secret sauce of this mechanism? The EcoScore—a detailed evaluation that
      //       ensures your investment backs a land with real ecological significance. This is a quick dive into how the
      //       EcoScore guarantees that investors’ and landowners’ needs are met through this transparent,
      //       crypto-integrated conservation system.
      //     </>
      //   ),
      // },
      { subtitle: "Here’s a summary:" },
      {
        paragraph: (
          <ul>
            {/* <span style={{ fontWeight: 600 }}>Here’s a summary:</span> */}
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub41");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              EFTs are pegged to the ecological wealth of real-world lands, allowing individuals and businesses to
              invest directly in nature, offset carbon and advocate environmental sustainability.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub42");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              The EcoScore is the valuation system behind EFTs, developed using ecological principles; it guarantees
              that investments are reciprocated with accurate environmental value, legitimizing carbon offsetting and
              advocacy efforts of investors.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub43");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              For landowners, the EcoScore provides a fair, accurate appraisal of land’s ecological value independent of
              real estate and commercial valuations.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub44");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              The EcoScore considers soil health, water quality and availability, carbon sequestration and forest
              maturity, and the diversity of flora and fauna, as well as energy use, waste management, and local
              employment.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub45");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              Further, EFTs employ a halving mechanism based on the Fibonacci sequence, triggering reduced mint rates as
              more land is added to the platform, thereby increasing token scarcity and value.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub46");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              EFTs are more than just investment vehicles—they are tools for advocacy, aligning financial incentives
              with ecological imperatives.
            </li>
            {/* <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub47");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>Read the EcoFutures whitepaper.</li> */}
          </ul>
        ),
      },
      { subtitle: { id: "sub41", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures (EFTs) is a green asset-backed NFT representing stakes in real-world lands that host living
            ecologies. EFTs facilitate a transparent, immutable and tamper-proof mechanism to support ecological assets
            for people and businesses that want to offset carbon emissions, advocate environmental sustainability, and
            support local communities that sustain natural ecosystems. With EFTs, you can directly invest in natural
            environments because the underlying asset they represent is the ecological value of a land parcel, not its
            commercial real estate value. The secret sauce of this mechanism? The EcoScore—a detailed evaluation that
            ensures your investment backs a land with real ecological significance. This is a quick dive into how the
            EcoScore guarantees that investors’ and landowners’ needs are met through this transparent,
            crypto-integrated conservation system.
          </>
        ),
      },
      { subtitle: { id: "sub42", text: "How the EcoScore considers soil health—the foundation of ecosystem integrity" } },
      {
        paragraph: (
          <>
            Soil health is a key determiner of the EcoScore. Soil structure, soil quality, soil biology, topsoil depth,
            density, and chemical composition are analyzed. High-scoring lands are nutrient-rich with deep topsoil,
            ensuring strong plant life and ecosystem sustainability—prime real estate for your green portfolio. Soil
            biology examines the presence and activity of organisms like microbes and earthworms, which are crucial for
            soil health. Abundant microbial and macrofaunal activity indicates a thriving ecosystem, making sure that
            the EcoScore reflects long-term ecological health.
          </>
        ),
      },
      { subtitle: { id: "sub43", text: "Factoring in water quality and availability means factoring in the potential for life" } },
      {
        paragraph: (
          <>
            Water is the lifeblood of any ecosystem, so the EcoScore assesses its quality and availability meticulously.
            It factors the type and flow of water sources, from periodic streams to perennial rivers. Robust, flowing
            water sources earn high scores, indicating resilient, well-hydrated ecosystems. The EcoScore also measures
            water quality by analyzing dissolved solids, contaminants, dissolved oxygen, and the presence of life forms.
            Clean water supporting diverse organisms scores high, ensuring that healthy aquatic ecosystems are indicated
            to investors through high EcoScores.
          </>
        ),
      },
      { subtitle: { id: "sub43", text: "Air and forest health; the central factor in carbon sequestration" } },
      {
        paragraph: (
          <>
            The EcoScore evaluates ecosystem services and photosynthetic biomass. This measures the land’s ability to
            sequester carbon and produce biomass. High carbon sequestration rates and substantial biomass scores
            indicate lands that significantly contribute to climate mitigation. The EcoScore considers forest maturity
            because it assesses the age and structural maturity of plant life. Older forests with continuous canopy
            cover score high, indicating stability and high ecological value, assuring investors with long-term forest
            health.
          </>
        ),
      },
      { subtitle: { id: "sub45", text: "Biodiversity; a key indicator of ecological health" } },
      {
        paragraph: (
          <>
            This component is assessed through flora and fauna evaluations. Flora diversity measures the variety of
            plant species, including trees and non-woody plants. High diversity, particularly in primary forests with
            ancient trees, signals a robust ecosystem with high ecological value. It also considers impervious land use;
            essentially, how much of the soil is covered by hard surfaces, which impacts plant growth. Lands with
            minimal impervious surfaces score high, signalling healthy, vibrant ecosystems rich with flora—exactly what
            eco-conscious investors should invest in. Fauna biodiversity measures species richness (alpha biodiversity)
            and population changes (beta biodiversity). Lands with a high number of species and keystone species score
            high, making sure the investments are supporting richly biodiverse ecosystems.
          </>
        ),
      },
      { subtitle: { id: "sub46", text: "Community and sustainability; the people keeping ecologies alive" } },
      {
        paragraph: (
          <>
            The EcoScore also considers the socio-economic impact on local communities. Sustainability evaluates energy
            use and waste management practices. Lands utilizing renewable energy and achieving zero waste score highest,
            reflecting a minimal environmental footprint. Employment assesses ecological job creation in local
            communities. Lands providing more employment opportunities score high, promoting socio-economic
            sustainability alongside ecological health.
          </>
        ),
      },
      { subtitle: { id: "sub47", text: "EFTs’ Halving Mechanism: Fibonacci-driven scarcity" } },
      {
        paragraph: (
          <>
            Incorporating original crypto principles, EcoFutures leverages the Fibonacci sequence to influence the
            distribution and value of EFTs. The halving of EFTs is linked to the number of lands uploaded to the
            platform. It utilizes a halving mechanism based on the Fibonacci sequence to ensure their value remains
            robust and sustainable.
          </>
        ),
      },
      {
        paragraph: (
          <>
            This scarcity principle mirrors the rising value of ecological assets as climate change worsens. As with all
            cryptocurrencies and tokens, the concept of halving is designed to mimic how traditional currencies, like
            gold, have natural scarcity which creates their value. As the total land added to the Eco Futures platform
            increases, halving thresholds are aligned with a Fibonacci-driven edition model. As each configured
            threshold is reached, a halving event is triggered.
            This means the global mint rate of EFTs decreases according to the inverse of the corresponding Fibonacci
            number (1/Fib). This systematic halving reduces the supply of EFTs, increasing their scarcity and value,
            incentivizing investors to support ecological conservation while enhancing the financial rewards associated
            with sustainable land management.
          </>
        ),
      },
      { subtitle: { id: "sub48", text: "What this means for investors, landowners, and the voluntary carbon market" } },

      {
        paragraph: (
          <>
            For investors, the EcoScore guarantees the ecological value of the lands they invest in, ensuring their
            crypto investments support genuinely sustainable ecosystems. Whether the motivation is to offset carbon or
            to contribute to nature conservation, the EcoScore provides a reliable, transparent indicator of the best
            investment decisions.
          </>
        ),
      },
      {
        paragraph: (
          <>
            For landowners, (termed Guardians once they get verified into the EcoFutures system) the EcoScore is a fair
            and accurate appraisal of their land’s ecological value. By listing their land on the EcoFutures platform,
            they contribute to global sustainability efforts, gain access to annual rewards, and join a community of
            environmentally conscious investors. The EcoScore’s thorough assessment process guarantees that the
            ecological contributions of their land are recognized and fairly valued
          </>
        ),
      },
      {
        paragraph: (
          <>
            The voluntary carbon market has long faced a trust issue, and EFTs offer a solution. For over a decade, the
            quality and efficacy of the existing carbon credit supply have been met with skepticism. The lack of
            transparency undermines the credibility of climate benefits and carbon offsetting claims. Blockchain
            applications and asset tokenization address this problem. EFTs, being immutable, tamper-proof, and
            transparent, can enhance the trust-building function of carbon markets. Trust in EFTs is fundamentally
            designed into the system, supported by technology that enforces, encrypts, and maintains it through a
            reliable network.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EFTs are more than just investment vehicles—they are tools for advocacy. They’re part of a crypto movement
            that calls for meaningful investment. Right now, in the backdrop of unprecedented climate change, few causes
            carry as much meaning as those influencing ecological and environmental sustainability. With EFTs, investors
            and Guardians are not only benefiting financially but are also becoming active players in environmental
            stewardship in this age where every action counts.
          </>
        ),
      },
      { subtitle: { id: "sub49", text: "Considering buying your own EFT? " } },


    ],
  },
  "blog-article-5": {
    title: "Why EFTs are the asset-backed NFTs the world really needs",
    thumbnail: { url: Valley, by: "Gez Xavier Mansfield" },
    updated: "Sep 11, 2024",
    data: [
      { subtitle: "Here’s a summary:" },
      {
        paragraph: (
          <ul>
            {/* <span style={{ fontWeight: 600 }}>Here’s a summary:</span> */}
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub51");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              EcoFutures Tokens (EFTs) are pegged to real-world assets with ecological value; like tropical jungles,
              permaculture farms or nature reserves sustained by people. As the value of ecological assets increases in
              rarity against the backdrop of rapid deforestation and expansion of built environments, so does the value
              of EFTs.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub52");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              EFTs respond to the growing need for making meaningful, ethical, and sustainable investment decisions
              based on environmental, social, and governance (ESG) factors.
            </li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub53");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>It’s a win-win-win for investors, and communities preserving natural lands and the environment.</li>
            <li style={{ cursor: "pointer" }} onClick={() => {
              const element = document.getElementById("sub54");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}>
              EcoFutures whitepaper helps investors understand how these asset-backed NFTs work and why the world needs
              them
            </li>
          </ul>
        ),
      },
      { subtitle: { id: "sub51", text: "Introduction" } },
      {
        paragraph: (
          <>
            One way of being actively grateful to the natural environment is to directly invest in promising ecologies. This is where TREEs come in.
          </>
        ),
      },
      { subtitle: { id: "sub52", text: "What investors need to know about how and why EFTs work" } },
      {
        paragraph: (
          <>
            Being alive today, on a planet in crisis, the gifts we’ve taken for granted are more obvious than ever
            before. The clean waterways, forests, fertile soil and oxygen-generating coral reefs are disappearing; the
            outcomes of our collective actions are toppling natural systems out of balance—a process that has no quick
            ‘off’ button. The aspiration to actively engage in offsetting environmental damage has never been a more
            popular aspiration. Parallelly in the crypto world—which has probably seen more meme coins than it needs
            to—there is a growing interest in investing more meaningfully. EcoFutures Tokens (EFTs) respond to both
            these shifts, allowing investors to translate their gratitude beyond the emotions while making meaningful
            investments and to get stakes on NFTs that more and more people want to get behind for the right reasons.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EFTs are asset-backed NFTs tied to real lands with ecological value as opposed to real estate worth. The
            environmental assets listed for bidding on EcoFutures Auction are all lands assessed and verified by the
            EcoFutures Trustee. You can read more about this process in a resource article dedicated to demystifying
            this process.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EFTs essentially link the human desire to generate wealth and the growing social ideal to support what
            sustains the balance of our environment. EcoFutures remedies eco guilt and the desire to align investments
            with meaning and purpose. With EFTs more crypto buyers can directly influence an important change they want
            to see in the world.
          </>
        ),
      },
      { subtitle: { id: "sub53", text: "Investing directly in natural resources—the ultimate wealth" } },
      {
        paragraph: (
          <>
            Nature is the ultimate wealth; the foremost resource we have. It’s a profitable entity beyond the
            traditional ways of harvesting or capturing its resources. There is tremendous value in nature preserved as
            it is. There is cultural, social, moral, aesthetic, and economic value in nature; stemming from that, there
            is also political value in nature, and to some, this goes even deeper to hold terminal, familial and
            personal value. This enormous and growing worth is what EcoFutures draws from to create value for its listed
            ecological assets and in turn, the EFTs. It creates income to maintain the ecological assets and the
            communities that protect them.
          </>
        ),
      },
      {
        paragraph: (
          <>
            In nature-rich yet economically challenged countries—like Sri Lanka, EcoFutures’ birthplace—there are
            significant extents of privately owned lands that have high ecological value with low financial resources to
            support their upkeep. With EcoFutures, it becomes possible for landowners to list their lands and become
            Guardians without having to sell their lands to real estate development projects. By making it possible for
            more people to put their gratitude into action and become direct investors or Guardians committed to
            preserving assets as natural environments, EFTs allow us all to engage in the survival of nature’s most
            essential reservoirs like rapidly disappearing old forests.
          </>
        ),
      },
      {
        paragraph: (
          <>
            In the longer run and at a larger scale, this is a part-solution for major ecological issues like loss of
            habitat, biodiversity, and threatened species. It’s also helping to solve the growing spiritual and
            psychological crisis caused by the disconnection between humans and nature.
          </>
        ),
      },
      { subtitle: { id: "sub54", text: "So many wins" } },
      {
        paragraph: (
          <>
            If we all do a little bit to invest in ecologies, we’ll end up doing quite a lot to nurture back the balance
            that Earth is losing. Because of the direct potential that EcoFutures offers investors to generate wealth,
            this entire process is now made profitable for both the planet and the people.
          </>
        ),
      },
      {
        paragraph: (
          <>
            For a long time, money-making and environmental conservation seemed hopelessly irreconcilable. EFTs change
            that. Now, anyone can invest directly into communities that conserve forests, and natural waters while
            benefiting from NFTs with high returns. So many wins.
          </>
        ),
      },
    ],
  },
};

export default blogs;
